// extracted by mini-css-extract-plugin
module.exports = {"itemRoot":"faq-item_itemRoot__EQO0y"};